// extracted by mini-css-extract-plugin
export default {"ClickableArea":"ClickableArea_ClickableArea__rMjgX","PlaceholderHide":"ClickableArea_PlaceholderHide__e4Xaa","SecondaryStyle":"ClickableArea_SecondaryStyle__3gQsk"};